<template>
	<div class="modify-stock">
		<el-dialog
			title="修改库存"
			top="4vh"
			width="800px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:visible.sync="dialogVisible"
			@close="closeDialog"
		>
			<el-row type="flex" justify="end">
				<el-button
					type="success"
					@click="handleUpload"
					:loading="loadingUpload"
					>上 传</el-button
				>
			</el-row>
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane
						:label="item.cusSku"
						:name="item.cusSku"
						:key="item.id"
					>
						<el-form class="custom-form" inline>
							<el-form-item label="库存">
								<el-input
									type="text"
									placeholder="请输入"
									v-model="formData.stock"
								></el-input>
							</el-form-item>
							<el-form-item label="预处理时间">
								<el-input
									type="text"
									placeholder="请输入"
									v-model="formData.preprocessingTime"
								></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="setTableVal"
									>设 置</el-button
								>
							</el-form-item>
						</el-form>
						<el-table
							ref="multipleTable"
							:data="[item]"
							border
							lazy
							:load="tableLoad"
							row-key="id"
							:tree-props="{
								children: 'children',
								hasChildren: 'variantCount',
							}"
						>
							<el-table-column
								align="center"
								width="50"
							></el-table-column>
							<el-table-column
								prop="cusSku"
								label="SKU"
								align="center"
								width="300"
							></el-table-column>
							<el-table-column
								prop="cusStock"
								label="库存"
								align="center"
							>
								<template slot-scope="scope">
									<el-input
										v-model="scope.row.cusStock"
									></el-input>
								</template>
							</el-table-column>
							<el-table-column
								prop="sucTime"
								label="预处理时间"
								align="center"
							>
								<template
									slot-scope="scope"
									v-if="scope.row.isShow"
								>
									<el-input
										type="text"
										v-model="scope.row.cusPreprocessingTime"
									></el-input>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitUpdate"
					:loading="loadingUpdate"
					>更 新</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
const variantMaps = new Map()

export default {
	name: 'ModifyStock',

	data() {
		return {
			dialogVisible: false,
			tabName: '',
			shopItem: null,
			listTabs: [],
			formData: {
				stock: '',
				preprocessingTime: '',
			},
			loadingUpdate: false,
			loadingUpload: false,
		}
	},
	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			this.tabName = list[0].cusSku
			this.handleTabClick()
			this.refreshTableLoad()
			this.dialogVisible = true
			this.isUpdate = false
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			this.tabIndex = this.listTabs.findIndex(
				(item) => item.cusSku === this.tabName
			)
			this.$nextTick(() => {
				const tabItem = this.listTabs[this.tabIndex]
				if (tabItem.children.length) {
					this.$refs.multipleTable[this.tabIndex].toggleRowExpansion(
						tabItem,
						true
					)
				}
			})
		},
		async tableLoad(tree, treeNode, resolve) {
			variantMaps.set(tree.id, { tree, treeNode, resolve })

			const variantData = await this.getTableItemVariant(tree)
			resolve(variantData)
		},
		refreshTableLoad() {
			try {
				this.listTabs.forEach((item) => {
					const itemObj = variantMaps.get(item.id)
					if (!itemObj) return
					const { tree, treeNode, resolve } = itemObj
					if (tree) {
						this.tableLoad(tree, treeNode, resolve)
					}
				})
			} catch (e) {
				console.log(e)
			}
		},
		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[tree.areaName]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${
								countryVal.currency
							})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							item.cusStock = item.stock
							item.cusImages = item.imagesList
						})
						this.listTabs[this.tabIndex].children = data
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		setTableVal() {
			const tempObj = this.listTabs[this.tabIndex]
			// 产品本身的值
			tempObj.cusStock = this.formData.stock
			tempObj.cusPreprocessingTime = this.formData.preprocessingTime

			// 产品中变体的值
			tempObj.children.forEach((item) => {
				item.cusStock = this.formData.stock
			})
			this.$forceUpdate()
		},
		handleTableVal(obj) {
			const resultTableVal = {
				product: {
					id: obj.id,
					stock: obj.cusStock,
					preprocessingTime: obj.cusPreprocessingTime,
				},
				variantEans: obj.children.map((item) => ({
					id: item.id,
					stock: item.cusStock,
				})),
			}

			// 处理数据：没有值，就不穿此key
			const tempObj = resultTableVal.product
			if (!tempObj.stock) {
				delete tempObj.stock
			}
			if (!tempObj.preprocessingTime) {
				delete tempObj.preprocessingTime
			}
			for (let item of resultTableVal.variantEans) {
				if (!item.stock) {
					delete item.stock
				}
			}
			// 处理数据：如果只有id，就不传值
			if (Object.keys(tempObj).length === 1 && !!tempObj.id) {
				delete resultTableVal.product
			}
			resultTableVal.variantEans = resultTableVal.variantEans.filter(
				(item) => Object.keys(item).length > 1 && !!item.id
			)
			if (!resultTableVal.variantEans.length) {
				delete resultTableVal.variantEans
			}

			return resultTableVal
		},
		submitUpdate() {
			const API =
				Baseurl + 'productController/batchUpdateProductAndVariant'
			const paramsData = this.handleTableVal(this.listTabs[this.tabIndex])
			if (!Object.keys(paramsData).length) return

			this.loadingUpdate = true
			this.isUpdate = true
			ajaxPost(API, paramsData).then((res) => {
				const { code } = res.data
				this.loadingUpdate = false
				if (code === 200) {
					this.$message.success('操作成功')
				}
			})
		},
		handleUpload() {
			const API = Baseurl + 'amaoznFeedUpload/saleProductSubmit'
			const paramsData = {
				ids: this.listTabs.map((item) => item.id),
				marketInfo: JSON.stringify({
					sellerId: this.shopItem.sellerId,
					mwsAuthToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketplaceId: this.shopItem.marketPlaceId,
				}),
				type: 5, // （基本信息1  图片3 价格4 库存5）
			}
			// console.log(JSON.parse(JSON.stringify(paramsData)))
			// return
			this.loadingUpload = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpload = false
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success(data)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.modify-stock {
	::v-deep {
		.custom-form {
			margin: 10px 0;

			.el-form-item {
				margin: 0;
			}

			.el-form-item + .el-form-item {
				margin-left: 10px;
			}
		}
	}
}
</style>
